module.exports = __webpack_public_path__ + "img/add-file-round-blue.4f742df3.svg";